import React from 'react';
import { CHAT_MODEL_OPTIONS } from '../../utils/chatHtmlReport';

export interface ChatModelSelectorProps {
  selectedModel: string;
  onChange: (model: string) => void;
  disabled?: boolean;
}

const ChatModelSelector: React.FC<ChatModelSelectorProps> = ({
  selectedModel,
  onChange,
  disabled = false,
}) => (
  <div className="flex items-center gap-2 shrink-0" role="group" aria-label="Claude model">
    {CHAT_MODEL_OPTIONS.map((opt) => {
      const active = selectedModel === opt.id;
      return (
        <button
          key={opt.id}
          type="button"
          title={`${opt.label}: ${opt.hint}`}
          disabled={disabled}
          onClick={() => onChange(opt.id)}
          className={`px-3 py-1.5 rounded-lg border text-[10px] font-bold tracking-widest uppercase transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${
            active
              ? 'bg-primary/20 border-primary text-primary'
              : 'bg-slate-900 border-slate-700 text-on-surface-variant hover:bg-slate-800 hover:text-on-surface'
          }`}
        >
          {opt.label}
        </button>
      );
    })}
  </div>
);

export default ChatModelSelector;
